import {ValueDispatcher, PresenterState} from '@cascade/core';

/**
 * Minimal stub replacing MC's Presenter class.
 * Remotion doesn't have a presentation/slide mode, so the presenter
 * always reports PresenterState.Initial, which keeps the editor in
 * normal mode (never enters PresentationMode).
 *
 * The UI reads:
 *  - `onStateChanged` (usePresenterState, Editor.tsx)
 *  - `onInfoChanged` (PresentationControls)
 *  - `onSlidesChanged` (SlideGraph)
 */
export class PresenterStub {
  public get onStateChanged() {
    return this._state.subscribable;
  }
  private readonly _state = new ValueDispatcher(PresenterState.Initial);

  public get onInfoChanged() {
    return this._info.subscribable;
  }
  private readonly _info = new ValueDispatcher({
    currentSlideId: null as string | null,
    nextSlideId: null as string | null,
    hasNext: false,
    hasPrevious: false,
    isWaiting: false,
    count: 0,
    index: null as number | null,
  });

  public get onSlidesChanged() {
    return this._slides.subscribable;
  }
  private readonly _slides = new ValueDispatcher<never[]>([]);

  public readonly stage: null = null;
  public readonly playback: null = null;

  public present() {
    // No-op: Remotion doesn't support slide presentations
  }

  public abort() {
    // No-op
  }

  public resume() {
    // No-op
  }

  public requestFirstSlide() {}
  public requestLastSlide() {}
  public requestPreviousSlide() {}
  public requestNextSlide() {}
  public requestSlide(_id: string) {}
}
